export interface GameSettings {
  readonly volume: number;
}

export const DEFAULT_SETTINGS: GameSettings = {
  volume: 0.7,
} as const;
